export type ApprovalStatus = "PENDING" | "IN_REVIEW" | "APPROVED" | "DENIED";

export type ApprovalType =
  | "TIME_OFF"
  | "EXPENSE"
  | "TIMESHEET"
  | "DOCUMENT"
  | "POLICY"
  | "JOB_CHANGE"
  | "EQUIPMENT"
  | "REMOTE_WORK";

export interface ApprovalRequest {
  id: string;
  org_id: string;
  type: ApprovalType;
  title: string;
  description: string | null;
  requestor_id: string;
  approver_id: string;
  status: ApprovalStatus;
  payload_json: Record<string, unknown> | null;
  reference_type: string | null;
  reference_id: string | null;
  reviewer_notes: string | null;
  resolved_at: string | null;
  created_at: string;
  requestor_name?: string | null;
  approver_name?: string | null;
}

export const APPROVAL_TYPE_LABELS: Record<ApprovalType, string> = {
  TIME_OFF: "Time Off",
  EXPENSE: "Expense",
  TIMESHEET: "Timesheet",
  DOCUMENT: "Document",
  POLICY: "Policy",
  JOB_CHANGE: "Job Change",
  EQUIPMENT: "Equipment",
  REMOTE_WORK: "Remote Work",
};

export const APPROVAL_STATUS_COLORS: Record<ApprovalStatus, string> = {
  PENDING: "warning",
  IN_REVIEW: "info",
  APPROVED: "success",
  DENIED: "danger",
};
